module.exports = __webpack_public_path__ + "img/kaoqin_banner.67de2552.png";